import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Input, InputLabel, MenuItem, Rating, Select, TextField, TextareaAutosize, Typography } from '@mui/material';
import oikosApi from '../../../services/oikos';
import qs from 'qs';
import { selectValues } from '../../../utils/fc';
import SearchableSelect from 'react-select';
import ModalFormAddFavBordero from '../../../components/Modals/ModalFormAddFavBordero/ModalFormAddFavBordero';

const DadosFavorecidoPj = ( props ) => {

  const [pj, setPj] = useState({});

  async function preloading() {

    if (Object.keys(props.selectedFav).length != 0) {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pj',
        fields: {},
        data: { pj_id: props.selectedFav.value }
      })}`);

      setPj(res.data[0])
    }

    else {
      setPj({})
    }
  }

  useEffect(() => {
    preloading()
  }, [props.selectedFav, props.refreshKey])

  const handleSelectChange = async (e) => {
    const selected = props.favs.find((pj) => {if(e) return pj.value === e.value});
    if (selected) {
      props.setSelectedFav(selected); // Update with the full pj object
      props.setFavChanged(true);
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pj',
        fields: {},
        data: { pj_id: selected.value }
      })}`);

      setPj(res.data[0])
    }
  };


  return (
    <DialogContent style={{overflow: 'visible'}}>
        <div className="d-flex">
        <div className='d-flex flex-column flex-fill'>
          <div>
            <span>Nome:</span><br/>
            <FormControl fullWidth>
              <SearchableSelect
                classNamePrefix="select2-selection"
                placeholder="Selecionar..."
                defaultValue={props.favs.find(x => x.value === props.data.bdro_favId)}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isSearchable={true}
                options={props.favs}
                onChange={handleSelectChange}
                value={props.selectedFav}
                />
            </FormControl>
          </div>
          {
            (Object.keys(pj).length === 0) ?
              <p>
                Sem informações sobre o favorecido.
              </p>
            :
          <>
            <div className='mt-3'>
              <span>CNPJ: </span><strong>{Object.keys(pj).length != 0 ? pj.pj_cnpj : ''}</strong>
            </div>
            <div className='mt-3'>
              <span>Dados Bancários:</span><br/>
              <div className='d-flex flex-column mt-3'>
                <div className='d-flex flex-column justify-content-between'>
                  <span style={{marginBottom: '3px'}}>Titular: <strong>{Object.keys(pj).length != 0 ? pj.pj_contaTitNome : ''}</strong></span>
                  <span style={{marginBottom: '3px'}}>Doc Titular: <strong>{Object.keys(pj).length != 0 ? pj.pj_contaTitDoc : ''}</strong></span>
                  <span style={{marginBottom: '3px'}}>Banco: <strong>{Object.keys(pj).length != 0 ? pj.pj_contaBanco: ''}</strong></span>
                  <span style={{marginBottom: '3px'}}>Agência: <strong>{Object.keys(pj).length != 0 ? pj.pj_contaAgencia : ''}</strong></span>
                  <span style={{marginBottom: '3px'}}>Número: <strong>{Object.keys(pj).length != 0 ? pj.pj_contaNum : ''}</strong></span>
                  <span style={{marginBottom: '3px'}}>Pix: <strong>{Object.keys(pj).length != 0 ? pj.pj_chavePix : ''}</strong></span>
                  <span style={{marginBottom: '3px'}}>Tipo de conta: <strong>{Object.keys(pj).length != 0 ? pj.pj_contaTp : ''}</strong></span>
                </div>
              </div>
            </div>
          </>
          }
        </div>
      </div>
    </DialogContent>
  )
}

export default DadosFavorecidoPj;
